/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserChallengeMembershipBody
 */
export interface UpdateUserChallengeMembershipBody {
    /**
     * When true, restore the membership to status="eligible". When false, mark status="disabled". Wire-name kept as `isActive` so existing admin clients keep working without a schema flip; the backend translates the boolean into the canonical MembershipStatus enum.
     * @type {boolean}
     * @memberof UpdateUserChallengeMembershipBody
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserChallengeMembershipBody
     */
    notes: string;
}

/**
 * Check if a given object implements the UpdateUserChallengeMembershipBody interface.
 */
export function instanceOfUpdateUserChallengeMembershipBody(value: object): value is UpdateUserChallengeMembershipBody {
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function UpdateUserChallengeMembershipBodyFromJSON(json: any): UpdateUserChallengeMembershipBody {
    return UpdateUserChallengeMembershipBodyFromJSONTyped(json, false);
}

export function UpdateUserChallengeMembershipBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserChallengeMembershipBody {
    if (json == null) {
        return json;
    }
    return {
        
        'isActive': json['isActive'],
        'notes': json['notes'],
    };
}

export function UpdateUserChallengeMembershipBodyToJSON(json: any): UpdateUserChallengeMembershipBody {
    return UpdateUserChallengeMembershipBodyToJSONTyped(json, false);
}

export function UpdateUserChallengeMembershipBodyToJSONTyped(value?: UpdateUserChallengeMembershipBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isActive': value['isActive'],
        'notes': value['notes'],
    };
}

